import CoinsIcon from './CoinsIcon'

export default CoinsIcon
